import { useState, useEffect, useRef } from 'react';
import styles from './IPurchase.module.css';

// ── Sample Data ───────────────────────────────────────────────
const SAMPLE_REQUISITIONS = [
  {
    id: 'PR-202509221177',
    date: '23 Sep',
    title: 'wefSDSDFSD',
    by: 'Kapil Patil',
    department: 'Information Technology',
    vendor: 'AMOL Traders',
    required_by: 'Sep 30, 2025',
    amount: 47200.00,
    status: 'Pending For Approval',
    type: 'Material Requisition',
    location: 'Corporate Office, Chinchwad',
    description: 'wefSDSDFSD',
    purchase_type: 'MISP-Purchase',
    budget_type: '01',
    budget_head: 'OPEX',
    letter_of_justification: false,
    submitted_on: 'Sep 23, 2025',
    requested_by: 'Kapil Patil',
  },
  {
    id: 'PR-202509221177',
    date: '22 Sep',
    title: "Hello, Kapil. Let's create your Purchase PO!",
    by: 'Kapil Patil',
    department: 'Information Technology',
    vendor: 'Control Tech Test',
    required_by: 'Sep 23, 2025',
    amount: 885.00,
    status: 'Pending For Approval',
    type: 'Material Requisition',
    location: 'Corporate Office, Chinchwad',
    description: "Hello, Kapil. Let's create your Purchase PO! Hello, Kapil. Let's create your Purchase PO!",
    purchase_type: 'MISP-Purchase',
    budget_type: '01',
    budget_head: 'CAPEX',
    letter_of_justification: false,
    submitted_on: 'Sep 22, 2025',
    requested_by: 'Kapil Patil',
  },
  {
    id: 'PR-202509221178',
    date: '22 Sep',
    title: 'Laptop Purchase for IT Team',
    by: 'Kapil Patil',
    department: 'Information Technology',
    vendor: 'Control Tech',
    required_by: 'Sep 30, 2025',
    amount: 18880.00,
    status: 'Pending For Approval',
    type: 'Material Requisition',
    location: 'Corporate Office, Chinchwad',
    description: 'Laptop Purchase for IT Team — 5 units required for new joinees',
    purchase_type: 'Direct-Purchase',
    budget_type: '01',
    budget_head: 'CAPEX',
    letter_of_justification: true,
    submitted_on: 'Sep 22, 2025',
    requested_by: 'Kapil Patil',
  },
  {
    id: 'PR-202509011145',
    date: '01 Sep',
    title: 'Material Purchase Requisition',
    by: 'Kapil Patil',
    department: 'Information Technology',
    vendor: 'Atlas Copco',
    required_by: 'Sep 15, 2025',
    amount: 125000.00,
    status: 'Approved',
    type: 'Material Requisition',
    location: 'Plant A — Pune',
    description: 'Raw material purchase for Q3 production',
    purchase_type: 'MISP-Purchase',
    budget_type: '02',
    budget_head: 'OPEX',
    letter_of_justification: true,
    submitted_on: 'Sep 01, 2025',
    requested_by: 'Kapil Patil',
  },
  {
    id: 'PR-202508281100',
    date: '28 Aug',
    title: 'Office Stationery Q3',
    by: 'Priya Sharma',
    department: 'Administration',
    vendor: 'Classmate Supplies',
    required_by: 'Sep 5, 2025',
    amount: 3200.00,
    status: 'Approved',
    type: 'Stationery Requisition',
    location: 'Corporate Office, Chinchwad',
    description: 'Monthly stationery supplies for admin team',
    purchase_type: 'Direct-Purchase',
    budget_type: '01',
    budget_head: 'OPEX',
    letter_of_justification: true,
    submitted_on: 'Aug 28, 2025',
    requested_by: 'Priya Sharma',
  },
  {
    id: 'PR-202508201088',
    date: '20 Aug',
    title: 'Safety Equipment Purchase',
    by: 'Ravi Kumar',
    department: 'Operations',
    vendor: 'SafeGuard India',
    required_by: 'Aug 30, 2025',
    amount: 56000.00,
    status: 'Rejected',
    type: 'Material Requisition',
    location: 'Plant B — Mumbai',
    description: 'PPE kits and safety helmets for plant floor workers',
    purchase_type: 'MISP-Purchase',
    budget_type: '01',
    budget_head: 'OPEX',
    letter_of_justification: false,
    submitted_on: 'Aug 20, 2025',
    requested_by: 'Ravi Kumar',
  },
];

const SIDEBAR_FILTERS = [
  { key: 'all',       label: 'All',                   count: 10 },
  { key: 'material',  label: 'Material Requisition',  count: 25 },
  { key: 'stationery_req', label: 'Stationery Requisition', count: 0 },
  { key: 'stationery_req2', label: 'Stationery Requests', count: 98 },
  { key: 'vendor',    label: 'iVendor',               count: null },
];

const STATUS_STYLES = {
  'Pending For Approval': { bg: '#ff9800', color: '#fff' },
  'Approved':             { bg: '#1a56db', color: '#fff' },
  'Rejected':             { bg: '#ef4444', color: '#fff' },
  'Draft':                { bg: '#94a3b8', color: '#fff' },
};

function fmt(n) {
  return '₹' + Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2 });
}

// ── New PR Modal ──────────────────────────────────────────────
function NewPRModal({ onClose, onSave }) {
  const [form, setForm] = useState({
    title: '', vendor: '', required_by: '', amount: '',
    department: 'Information Technology', type: 'Material Requisition',
    location: 'Corporate Office, Chinchwad', purchase_type: 'MISP-Purchase',
    budget_head: 'OPEX', description: '', letter_of_justification: false,
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = () => {
    if (!form.title || !form.vendor || !form.amount) {
      alert('Please fill all required fields');
      return;
    }
    onSave({
      ...form,
      id: `PR-${Date.now()}`,
      date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
      status: 'Pending For Approval',
      by: 'Admin User',
      submitted_on: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      requested_by: 'Admin User',
    });
  };

  return (
    <div className={styles.modal_overlay} onClick={e => e.target === e.currentTarget}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.modal_header}>
          <h2>New Purchase Requisition</h2>
          <button onClick={onClose} className={styles.modal_close}>✕</button>
        </div>
        <div className={styles.modal_body}>
          <div className={styles.form_grid}>
            <div className={styles.form_group} style={{ gridColumn: '1/-1' }}>
              <label>Title / Description *</label>
              <input value={form.title} onChange={e => set('title', e.target.value)} placeholder="Enter requisition title" />
            </div>
            <div className={styles.form_group}>
              <label>Vendor *</label>
              <input value={form.vendor} onChange={e => set('vendor', e.target.value)} placeholder="Vendor name" />
            </div>
            <div className={styles.form_group}>
              <label>Amount (₹) *</label>
              <input type="number" value={form.amount} onChange={e => set('amount', e.target.value)} placeholder="0.00" />
            </div>
            <div className={styles.form_group}>
              <label>Required By</label>
              <input type="date" value={form.required_by} onChange={e => set('required_by', e.target.value)} />
            </div>
            <div className={styles.form_group}>
              <label>Type</label>
              <select value={form.type} onChange={e => set('type', e.target.value)}>
                <option>Material Requisition</option>
                <option>Stationery Requisition</option>
              </select>
            </div>
            <div className={styles.form_group}>
              <label>Department</label>
              <input value={form.department} onChange={e => set('department', e.target.value)} />
            </div>
            <div className={styles.form_group}>
              <label>Location</label>
              <input value={form.location} onChange={e => set('location', e.target.value)} />
            </div>
            <div className={styles.form_group}>
              <label>Purchase Type</label>
              <select value={form.purchase_type} onChange={e => set('purchase_type', e.target.value)}>
                <option>MISP-Purchase</option>
                <option>Direct-Purchase</option>
              </select>
            </div>
            <div className={styles.form_group}>
              <label>Budget Head</label>
              <select value={form.budget_head} onChange={e => set('budget_head', e.target.value)}>
                <option>OPEX</option>
                <option>CAPEX</option>
              </select>
            </div>
            <div className={styles.form_group} style={{ gridColumn: '1/-1' }}>
              <label>Description</label>
              <textarea value={form.description} onChange={e => set('description', e.target.value)} rows={3} placeholder="Additional details…" />
            </div>
            <div className={styles.form_group}>
              <label className={styles.checkbox_label}>
                <input type="checkbox" checked={form.letter_of_justification} onChange={e => set('letter_of_justification', e.target.checked)} />
                Letter of Justification attached
              </label>
            </div>
          </div>
        </div>
        <div className={styles.modal_footer}>
          <button className={styles.btn_cancel} onClick={onClose}>Cancel</button>
          <button className={styles.btn_submit} onClick={handleSubmit}>Submit Requisition</button>
        </div>
      </div>
    </div>
  );
}

// ── Detail Panel ──────────────────────────────────────────────
function DetailPanel({ item, onClose }) {
  if (!item) return null;
  return (
    <div className={styles.detail_panel}>
      <div className={styles.detail_title}>Hello, Kapil. Let's create your Purchase PO!</div>
      <div className={styles.detail_id}>ID: {item.id}</div>
      <p className={styles.detail_desc}>{item.description}</p>

      <div className={styles.detail_row}><span>Submitted on:</span><strong>{item.submitted_on}</strong></div>
      <div className={styles.detail_row}><span>Location:</span><strong>{item.location}</strong></div>
      <div className={styles.detail_row}>
        <span>Requested by:</span>
        <strong className={styles.detail_link}>{item.requested_by}</strong>
      </div>

      <div className={styles.detail_divider} />
      <div className={styles.detail_section}>Purchase Details</div>

      <div className={styles.detail_row}>
        <span>Letter of Justification:</span>
        <strong>{item.letter_of_justification ? '✅' : '❌'}</strong>
      </div>
      <div className={styles.detail_row}><span>Location:</span><strong>{item.location}</strong></div>
      <div className={styles.detail_row}><span>Purchase type:</span><strong>{item.purchase_type}</strong></div>
      <div className={styles.detail_row}><span>Budget type:</span><strong>{item.budget_type}</strong></div>
      <div className={styles.detail_row}><span>Budget Head:</span><strong>{item.budget_head}</strong></div>
      <div className={styles.detail_row}><span>Amount:</span><strong>{fmt(item.amount)}</strong></div>
      <div className={styles.detail_row}><span>Vendor:</span><strong>{item.vendor}</strong></div>

      <button className={styles.view_btn}>View / Approve Purchase Requisition</button>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────
export default function IPurchasePage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [search, setSearch]             = useState('');
  const [selected, setSelected]         = useState(SAMPLE_REQUISITIONS[1]);
  const [showModal, setShowModal]       = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [items, setItems]               = useState(SAMPLE_REQUISITIONS);
  const dropRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handler = e => { if (dropRef.current && !dropRef.current.contains(e.target)) setShowDropdown(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = items.filter(item => {
    const matchSearch = !search || item.title.toLowerCase().includes(search.toLowerCase()) ||
      item.vendor.toLowerCase().includes(search.toLowerCase());
    const matchFilter = activeFilter === 'all' ||
      (activeFilter === 'material' && item.type === 'Material Requisition') ||
      (activeFilter === 'stationery_req' && item.type === 'Stationery Requisition');
    return matchSearch && matchFilter;
  });

  const handleSave = (pr) => {
    setItems(prev => [pr, ...prev]);
    setSelected(pr);
    setShowModal(false);
  };

  return (
    <div className={styles.page}>

      {/* ── Toolbar ── */}
      <div className={styles.toolbar}>
        {/* New Button with dropdown */}
        <div className={styles.new_btn_wrap} ref={dropRef}>
          <button className={styles.new_btn_main} onClick={() => setShowModal(true)}>
            New
          </button>
          <button
            className={styles.new_btn_arrow}
            onClick={() => setShowDropdown(d => !d)}
          >
            ▾
          </button>
          {showDropdown && (
            <div className={styles.new_dropdown}>
              <div className={styles.new_dropdown_item} onClick={() => { setShowModal(true); setShowDropdown(false); }}>
                📋 Material Requisition
              </div>
              <div className={styles.new_dropdown_item} onClick={() => { setShowModal(true); setShowDropdown(false); }}>
                📎 Stationery Requisition
              </div>
            </div>
          )}
        </div>

        {/* Search bar */}
        <div className={styles.search_wrap}>
          <span className={styles.search_icon}>🔍</span>
          <input
            className={styles.search_input}
            type="text"
            placeholder="Search in all Purchase Requisition"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button className={styles.filter_btn} title="Filter">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/>
            </svg>
          </button>
        </div>
      </div>

      {/* ── Body: 3-column layout ── */}
      <div className={styles.body}>

        {/* Left filter sidebar */}
        <div className={styles.filter_col}>
          {SIDEBAR_FILTERS.map(f => (
            <div
              key={f.key}
              className={`${styles.filter_item} ${activeFilter === f.key ? styles.filter_active : ''}`}
              onClick={() => setActiveFilter(f.key)}
            >
              <span className={styles.filter_label}>{f.label}</span>
              {f.count !== null && (
                <span className={`${styles.filter_count} ${activeFilter === f.key ? styles.filter_count_active : ''}`}>
                  {f.count}
                </span>
              )}
            </div>
          ))}
        </div>

        {/* ── Center list ── */}
        <div className={styles.list_col}>
          {filtered.length === 0 ? (
            <div className={styles.empty}>No requisitions found</div>
          ) : (
            filtered.map((item, i) => (
              <div
                key={i}
                className={`${styles.card} ${selected?.id === item.id && selected?.title === item.title ? styles.card_active : ''}`}
                onClick={() => setSelected(item)}
              >
                <div className={styles.card_date}>{item.date}</div>
                <div className={styles.card_content}>
                  <div className={styles.card_title}>
                    {item.title}
                    {' '}
                    <span className={styles.card_meta}>
                      | By: {item.by} | {item.department}
                    </span>
                  </div>
                  <div className={styles.card_sub}>
                    Vendor: {item.vendor} &nbsp;|&nbsp; Required by: {item.required_by} &nbsp;|&nbsp; Amount:
                  </div>
                  <div className={styles.card_amount}>{fmt(item.amount)}</div>
                </div>
                <div className={styles.card_status_wrap}>
                  <span
                    className={styles.card_status}
                    style={{
                      background: STATUS_STYLES[item.status]?.bg || '#94a3b8',
                      color: STATUS_STYLES[item.status]?.color || '#fff',
                    }}
                  >
                    {item.status}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Right detail panel */}
        <div className={styles.detail_col}>
          {selected
            ? <DetailPanel item={selected} onClose={() => setSelected(null)} />
            : <div className={styles.detail_empty}>Select a requisition to view details</div>
          }
        </div>
      </div>

      {showModal && <NewPRModal onClose={() => setShowModal(false)} onSave={handleSave} />}
    </div>
  );
}
